<template>
  <div class="upload" v-loading="loading">
    <div class="upload-list">
      <template v-if="images.length > 0">
        <div v-for="(item, index) in images" :key="item.key" class="preview">
          <div class="preview-img-box" :style="{ height: height + 'px', width: width + 'px' }">
            <img v-if="item.preview" class="preview-img" :src="`${item.preview}?imageView2/2/w${width}/h/${height}`" />
            <template v-if="images.length > 1 && sortable">
              <div @click="doSort(-1, index, item)" v-if="index != 0" class="move move-left">
                <i class="iconfont icon-arrow-left"></i>
              </div>
              <div @click="doSort(1, index, item)" v-if="index != images.length - 1" class="move move-right">
                <i class="iconfont icon-arrow-right"></i>
              </div>
            </template>

            <div class="preview-footer" :style="{ width: width + 'px' }">
              <div class="name v-ellipsis"></div>
              <i @click.stop="openWindow(item.preview)" class="operate-btn el-icon-zoom-in"></i>
              <i @click.stop="deleteImage(index)" class="operate-btn el-icon-delete"></i>
            </div>

            <div v-if="item.uploading" class="uploading-mask">
              <div v-if="item.oversize">
                <el-link type="danger" style="font-size: 12px;line-height: 20px">文件体积过大,最大支持{{ maxSize / 1024 }}M</el-link>
                <div>
                  <i class="operate-btn el-icon-delete" @click="lists.splice(index, 1)"></i>
                </div>
              </div>
              <el-progress v-else style="width:120px;margin: 0 auto;" :text-inside="true" :stroke-width="24" :percentage="item.percent" status="success"></el-progress>
            </div>
          </div>
        </div>
      </template>

      <div v-if="images.length < max && control" class="upload-btn" :style="{ height: height + 'px', width: width + 'px' }" @click="chooseFile">
        <i class="icon el-icon-plus"></i>
      </div>
    </div>
    <input ref="fileInput" hidden class="file" type="file" :multiple="max > 1" accept="image/*" />
  </div>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: '100',
    },
    height: {
      type: String,
      default: '100',
    },
    max: { type: Number, default: 1 },
    maxSize: {
      type: String,
      default: String(1024 * 20),
    },
    keys: {
      type: Array,
      default: function() {
        return [];
      },
    },
    sortable: { type: Boolean, default: false },
    toolbar: { type: Boolean, default: true },
    control: { type: Boolean, default: true },
  },

  model: {
    prop: 'keys',
    event: 'change',
  },

  computed: {
    images() {
      return this.keys;
    },
  },

  data() {
    return {
      loading: false,
      isShowMedia: false,
      uploadLoading: false,
    };
  },

  methods: {
    openWindow(url) {
      window.open(url, '_blank');
    },

    chooseFile() {
      let fileInput = this.$refs.fileInput;
      fileInput.click();
      fileInput.onchange = (e) => {
        let files = e.target.files;
        this.doUpload(files);
      };
    },

    doUpload(files) {
      this.uploadLoading = true;
      let images = JSON.parse(JSON.stringify(this.images));
      let uploaded = [];
      let uploading = Array.from(files).map((item) => {
        return {
          name: item.name,
          size: item.size,
          uploading: true,
          percent: 0,
          file: item,
          oversize: item.size / 1024 >= this.maxSize,
        };
      });
      images = images.concat(uploading);
      if (images.length > this.max) {
        images.length = this.max;
        this.$message.error(`最多上传${this.max}张图片`);
      }
      this.$emit('change', images);
      images.forEach((item, index) => {
        if (item.oversize || !item.uploading) {
          return;
        }
        (async () => {
          let res = await this.utils.upload.uploadFile(item.file, {
            progress: (data) => {
              item.percent = parseInt(data.total.percent);
            },
          });
          uploaded.push(res);
          this.$set(images, index, res);
          this.$emit('change', images);
          if (uploaded.length == uploading.filter((item) => !item.oversize).length) {
            this.uploadLoading = false;
            this.$refs.fileInput.value = '';
          }
        })();
      });
    },

    //删除图片
    deleteImage(index) {
      let images = JSON.parse(JSON.stringify(this.images));
      images.splice(index, 1);
      this.$emit('change', images);
    },

    //排序
    doSort(step, index, row) {
      let images = JSON.parse(JSON.stringify(this.images));
      images.splice(index, 1);
      images.splice(index + step, 0, row);
      this.$emit('change', images);
    },
  },
};
</script>

<style lang="scss" scoped>
.upload {
  display: flex;
  user-select: none;
  flex-wrap: wrap;
}

.upload-image {
  position: relative;
}

.upload-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px dashed #9a9a9a;
  border-radius: 4px;
  cursor: pointer;
  color: #9a9a9a;
  box-sizing: border-box;
  margin: 0 10px 0 0;

  .icon {
    font-size: 22px;
  }

  .txt {
    font-size: 12px;
  }
}

.upload-list {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
}

.upload-list .preview {
  position: relative;
  margin: 0 10px 10px 0;
}

.upload-list .preview-img {
  display: block;
  cursor: pointer;
  width: 100%;
  height: 100%;
}

.preview-footer {
  display: flex;
  font-size: 12px;
  line-height: 25px;
  background: rgba(0, 0, 0, 0.3);
  color: #fff;
  align-items: center;
  transition: all 0.3s ease;
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 0;
  overflow: hidden;
}

.preview-img-box:hover .preview-footer {
  height: 25px;
}

.preview-footer .name {
  flex: 1;
  font-size: 12px;
  padding: 0 10px;
  height: 25px;
}

.preview-footer .operate-btn {
  color: #fff;
  margin-right: 10px;
  cursor: pointer;
  line-height: 25px;
}

.preview-img-box {
  position: relative;
  border: 1px dashed #eee;
  border-radius: 4px;
  overflow: hidden;
}

.preview-img-box .move {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  display: none;
  cursor: pointer;
}

.preview-img-box:hover .move {
  display: flex;
}

.preview-img-box .move .iconfont {
  font-size: 12px;
}

.preview-img-box .move-left {
  left: 0;
}

.preview-img-box .move-right {
  right: 0;
}

.uploading-mask {
  background: rgba(255, 255, 255, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
</style>
